<template>
<div>
	<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
		<div class="foot-tab-head">
			<div class="foot-tab-row-label"
           :class="[windowWidth < 460 ? 'blur-right shadow-[-1px_0_0_0_#3A4B64] !min-w-[130px] !w-[130px] !max-w-[130px] !sticky' : '']">
				<span class="cursor-pointer underline zt-hover min-w-[18px] whitespace-nowrap pl-[10px]"
              @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
				<span class="cursor-pointer underline zt-hover truncate pl-1 xl:pl-0"
				      :class="{ '!no-underline' : sortColumn === 'name' }"
				      @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
			</div>
			<div class="flex !text-[11px] font-['Lato']" :class="{'-ml-[1px]' : type !== 'all'}">
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === 'matches', 'disabled-sort' : type === 'all' }"
				     @click="sortTable('matches', $event, false, type === 'all')"><div>M</div></div>
				<div class="foot-tab-row-item brightness-100"
				     :class="{ '!no-underline' : sortColumn === '1-15', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('1-15', $event, false, type === 'all')"><div class="!font-['lato']">1-15</div></div>
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === '16-30', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('16-30', $event, false, type === 'all')"><div class="!font-['lato']">16-30</div></div>
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === '31-45', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('31-45', $event, false, type === 'all')"><div class="!font-['lato']">31-45</div></div>
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === '46-60', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('46-60', $event, false, type === 'all')"><div class="!font-['lato']">46-60</div></div>
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === '61-75', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('61-75', $event, false, type === 'all')"><div class="!font-['lato']">61-75</div></div>
				<div class="foot-tab-row-item"
				     :class="{ '!no-underline' : sortColumn === '76-90', 'disabled-sort !w-11' : type === 'all' }"
				     @click="sortTable('76-90', $event, false, type === 'all')"><div class="!font-['lato']">76-90</div></div>
				<div v-if="type !== 'all'" class="foot-tab-row-item foot-tab-row-item-family ml-3"
				     :class="{ '!no-underline' : sortColumn === '1.p' }"
				     @click="sortTable('1.p', $event)"><div>1.P</div></div>
        <div v-if="type !== 'all'" class="foot-tab-row-item foot-tab-row-item-family"
				     :class="{ '!no-underline' : sortColumn === '2.p' }"
				     @click="sortTable('2.p', $event)"><div>2.P</div></div>
			</div>
		</div>
		<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!pl-0' : window.size.mobile, '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
		     v-for="(team, index) in leagueTable" :key="team.team_id">
			<div class="foot-tab-row-label"
           :class="[windowWidth < 460 ? 'blur-right shadow-[-1px_0_0_0_#3A4B64] !min-w-[130px] !w-[130px] !max-w-[130px] !sticky' : '', { '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }]">
        <transition appear name="fade" mode="out-in">
          <p :key="filterKey" class="flex items-center" :class="{ 'pl-[10px] pr-1' : window.size.mobile }">
            <span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
                <span class="flex items-center mr-2 aspect-square h-5">
                  <TeamImg :team="team"/>
                </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
            <span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
          </p>
        </transition>
			</div>
      <transition appear name="fade" mode="out-in">
        <div :key="filterKey" class="flex" :class="{'-ml-[1px]' : type !== 'all'}">
          <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
            <div>{{ matchesLocalAway(team.team_id) }}</div>
          </div>
          <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === '1-15' && type !== 'all' , '!px-0 !w-11' : type === 'all' }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 1, 15) }" v-html="getGoalsInQuarters(team, 1, 15)"></div>
          </div>
          <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === '16-30' && type !== 'all', '!px-0 !w-11' : type === 'all' }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 16, 30) }" v-html="getGoalsInQuarters(team, 16, 30)"></div>
          </div>
          <div class="foot-tab-row-item border-r-[1px] border-zt-light" :class="{ 'foot-tab-row-item-active' : sortColumn === '31-45' && type !== 'all', '!w-11' : type === 'all'  }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 31, 45) }" v-html="getGoalsInQuarters(team, 31, 45)"></div>
          </div>
          <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === '46-60' && type !== 'all', '!px-0' : type === 'all', '!w-11' : type === 'all' }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 46, 60) }" v-html="getGoalsInQuarters(team, 46, 60)"></div>
          </div>
          <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === '61-75' && type !== 'all', '!px-0' : type === 'all','!w-11' : type === 'all' }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 61, 75) }" v-html="getGoalsInQuarters(team, 61, 75)"></div>
          </div>
          <div class="foot-tab-row-item !px-0" :class="{ 'foot-tab-row-item-active' : sortColumn === '76-90' && type !== 'all', '!w-11' : type === 'all' }">
            <div class="font-['lato']" :class="{ 'marked-box' : isHighestValue(team, 76, 90) }" v-html="getGoalsInQuarters(team, 76, 90)"></div>
          </div>
          <div v-if="type !== 'all'" class="foot-tab-row-item foot-tab-row-item-family ml-3" :class="{ 'foot-tab-row-item-active' : sortColumn === '1.p' }">
            <div class="font-['lato']">{{ goalsInQuarter(team, 1, 15) + goalsInQuarter(team, 16, 30) + goalsInQuarter(team, 31, 45) }}</div>
          </div>
          <div v-if="type !== 'all'" class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === '2.p' }">
            <div class="font-['lato']">{{ goalsInQuarter(team, 46, 60) + goalsInQuarter(team, 61, 75) + goalsInQuarter(team, 76, 90) }}</div>
          </div>
        </div>
      </transition>
		</div>
	</div>
</div>
</template>

<script>
import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'QuartersTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		quarterStats: {
			type: Object,
			required: true,
		},
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	inject: ['WP'],
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'name',
			displayedTable: 'all',
			sortAscending: 1,
			currentSubTab: this.filters[2] ?? 'all',
			type: 'all',
			teamsSorted: this.teams,
			events: [],
			isLpSet: false,
			windowWidth: window.innerWidth,
		}
	},
	mounted() {
		window.onresize = () => {
			this.windowWidth = window.innerWidth;
		}
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    boxSize() {
      return this.view === 'compact' ? '22px' : '25px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length) {
				return this.teamsSorted.slice().sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
        this.type = newVal[1];
				this.currentSubTab = newVal[2];
        this.setGoalsInQuarters();
        let teams_temp = this.teams.sort(this.sortTeams);
        teams_temp.forEach((team, i) => { team.currentTablePosition = i+1; });
        this.teamsSorted = teams_temp;
			}, 250);
		},
	},
	methods: {
		matchesLocalAway(team_id) {
			if (this.currentSubTab === 'all') {
				return this.quarterStats[team_id]?.all_matches;
			} else if (this.currentSubTab === 'home') {
				return this.quarterStats[team_id]?.local_matches;
			} else {
				return this.quarterStats[team_id]?.visitor_matches;
			}
		},
		goalsInQuarter(team, minTime, maxTime) {
			if (this.type === 'all') {
				if (this.currentSubTab === 'all') {
          const obtained = this.quarterStats[team.team_id]?.goals.obtained.all[`${minTime}-${maxTime}`];
          const lost = this.quarterStats[team.team_id]?.goals.lost.all[`${minTime}-${maxTime}`];
          const color = obtained > lost ? '#32AB29' : obtained < lost ? '#CE2121' : '#F2C309';
					return `<span style="color: ${color}">${obtained}:${lost}</span>`;
				} else if (this.currentSubTab === 'home') {
          const obtained = this.quarterStats[team.team_id]?.goals.obtained.home[`${minTime}-${maxTime}`];
          const lost = this.quarterStats[team.team_id]?.goals.lost.home[`${minTime}-${maxTime}`];
          const color = obtained > lost ? '#32AB29' : obtained < lost ? '#CE2121' : '#F2C309';
          return `<span style="color: ${color}">${obtained}:${lost}</span>`;
				} else if (this.currentSubTab === 'away') {
          const obtained = this.quarterStats[team.team_id]?.goals.obtained.away[`${minTime}-${maxTime}`];
          const lost = this.quarterStats[team.team_id]?.goals.lost.away[`${minTime}-${maxTime}`];
          const color = obtained > lost ? '#32AB29' : obtained < lost ? '#CE2121' : '#F2C309';
          return `<span style="color: ${color}">${obtained}:${lost}</span>`;
				}
			} else if (this.type === 'obtained') {
				if (this.currentSubTab === 'all') {
					return this.quarterStats[team.team_id]?.goals.obtained.all[`${minTime}-${maxTime}`];
				} else if (this.currentSubTab === 'home') {
					return this.quarterStats[team.team_id]?.goals.obtained.home[`${minTime}-${maxTime}`];
				} else if (this.currentSubTab === 'away') {
					return this.quarterStats[team.team_id]?.goals.obtained.away[`${minTime}-${maxTime}`];
				}
			} else if (this.type === 'lost') {
				if (this.currentSubTab === 'all') {
					return this.quarterStats[team.team_id]?.goals.lost.all[`${minTime}-${maxTime}`];
				} else if (this.currentSubTab === 'home') {
					return this.quarterStats[team.team_id]?.goals.lost.home[`${minTime}-${maxTime}`];
				} else if (this.currentSubTab === 'away') {
					return this.quarterStats[team.team_id]?.goals.lost.away[`${minTime}-${maxTime}`];
				}
			}
		},
		goalsInQuartersAndSetPoints(team, minTime, maxTime) {
			const sum = this.goalsInQuarter(team, minTime, maxTime);
			const teamIndex = this.teams.findIndex(t => team.team_id === t.team_id);
			this.teams[teamIndex][`${minTime}-${maxTime}`] = sum;
		},
    getGoalsInQuarters(team, minTime, maxTime) {
      const teamIndex = this.teams.findIndex(t => team.team_id === t.team_id);
      if(teamIndex !== -1) {
        return this.teams[teamIndex][`${minTime}-${maxTime}`]
      } else {
        return 0;
      }
    },
    setGoalsInQuarters(){
      const quarters = [
        [1,15],
        [16,30],
        [31,45],
        [46,60],
        [61,75],
        [76,90]
      ];
      this.teams.forEach(team => {
        quarters.forEach(quarter => {
          this.goalsInQuartersAndSetPoints(team, quarter[0], quarter[1]);
        });
      });
    },
		sortTeams(a, b) {
			let diff = 0;
      if (this.type === 'all') {
        const quarters = [
          [1,15],
          [16,30],
          [31,45],
          [46,60],
          [61,75],
          [76,90]
        ];
        const aGreens = quarters.map(quarter => {
          let val = this.goalsInQuarter(a, quarter[0], quarter[1]);
          val = val.replace(/<[^>]*>?/gm, '');
          return val;
        });
        const bGreens = quarters.map(quarter => {
          let val = this.goalsInQuarter(b, quarter[0], quarter[1]);
          val = val.replace(/<[^>]*>?/gm, '');
          return val;
        });
        const reducer = (acc, val) => {
          const [obtained, lost] = val.split(':');
          if (obtained > lost) {
            return acc + 3;
          } else if (obtained === lost) {
            return acc + 1;
          } else {
            return acc;
          }
        };
        const aSum = aGreens.reduce((acc, val) => reducer(acc, val), 0);
        const bSum = bGreens.reduce((acc, val) => reducer(acc, val), 0);
        if (this.sortAscending) {
          diff = aSum - bSum;
        } else {
          diff = bSum - aSum;
        }
      } else {
        switch (this.sortColumn) {
          case 'bm':
            if (this.sortAscending) {
              diff = +this.allGoals(a).split(':')[0] - +this.allGoals(b).split(':')[0] || +this.allGoals(b).split(':')[1] - +this.allGoals(a).split(':')[1];
            } else {
              diff = +this.allGoals(b).split(':')[0] - +this.allGoals(a).split(':')[0] || +this.allGoals(a).split(':')[1] - +this.allGoals(b).split(':')[1];
            }
            break;
          case '1.p':
            if (this.sortAscending) {
              diff = (this.goalsInQuarter(a, 1, 15) + this.goalsInQuarter(a, 16, 30) + this.goalsInQuarter(a, 31, 45))
                  - (this.goalsInQuarter(b, 1, 15) + this.goalsInQuarter(b, 16, 30) + this.goalsInQuarter(b, 31, 45));
            } else {
              diff = (this.goalsInQuarter(b, 1, 15) + this.goalsInQuarter(b, 16, 30) +this.goalsInQuarter(b, 31, 45))
                  - (this.goalsInQuarter(a, 1, 15) + this.goalsInQuarter(a, 16, 30) +this.goalsInQuarter(a, 31, 45));
            }
            break;
          case '2.p':
            if (this.sortAscending) {
              diff = (this.goalsInQuarter(a, 46, 60) + this.goalsInQuarter(a, 61, 75) + this.goalsInQuarter(a, 76, 90))
                  - (this.goalsInQuarter(b, 46, 60) + this.goalsInQuarter(b, 61, 75) + this.goalsInQuarter(b, 76, 90));
            } else {
              diff = (this.goalsInQuarter(b, 46, 60) + this.goalsInQuarter(b, 61, 75) + this.goalsInQuarter(b, 76, 90))
                  - (this.goalsInQuarter(a, 46, 60) + this.goalsInQuarter(a, 61, 75) + this.goalsInQuarter(a, 76, 90));
            }
            break;
          case 'matches':
            if (this.sortAscending) {
              diff = this.matchesLocalAway(a.team_id) - this.matchesLocalAway(b.team_id);
            } else {
              diff = this.matchesLocalAway(b.team_id) - this.matchesLocalAway(a.team_id);
            }
            break;
          case '1-15':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 1, 15) - this.goalsInQuarter(b, 1, 15);
            } else {
              diff = this.goalsInQuarter(b, 1, 15) - this.goalsInQuarter(a, 1, 15);
            }
            break;
          case '16-30':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 16, 30) - this.goalsInQuarter(b, 16, 30);
            } else {
              diff = this.goalsInQuarter(b, 16, 30) - this.goalsInQuarter(a, 16, 30);
            }
            break;
          case '31-45':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 31, 45) - this.goalsInQuarter(b, 31, 45);
            } else {
              diff = this.goalsInQuarter(b, 31, 45) - this.goalsInQuarter(a, 31, 45);
            }
            break;
          case '46-60':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 46, 60) - this.goalsInQuarter(b, 46, 60);
            } else {
              diff = this.goalsInQuarter(b, 46, 60) - this.goalsInQuarter(a, 46, 60);
            }
            break;
          case '61-75':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 61, 75) - this.goalsInQuarter(b, 61, 75);
            } else {
              diff = this.goalsInQuarter(b, 61, 75) - this.goalsInQuarter(a, 61, 75);
            }
            break;
          case '76-90':
            if (this.sortAscending) {
              diff = this.goalsInQuarter(a, 76, 90) - this.goalsInQuarter(b, 76, 90);
            } else {
              diff = this.goalsInQuarter(b, 76, 90) - this.goalsInQuarter(a, 76, 90);
            }
            break;
          default:
            if (this.sortAscending) {
              diff = this.getPoints(a) - this.getPoints(b);
            } else {
              diff = this.getPoints(b) - this.getPoints(a);
            }
            break;
        }
      }
      if (diff === 0) {
        if (this.sortAscending) {
          diff = (this.goalsInQuarter(a, 1, 15) + this.goalsInQuarter(a, 16, 30) + this.goalsInQuarter(a, 31, 45) +
              this.goalsInQuarter(a, 46, 60) + this.goalsInQuarter(a, 61, 75) + this.goalsInQuarter(a, 76, 90)) -
              (this.goalsInQuarter(b, 1, 15) + this.goalsInQuarter(b, 16, 30) + this.goalsInQuarter(b, 31, 45) +
                  this.goalsInQuarter(b, 46, 60) + this.goalsInQuarter(b, 61, 75) + this.goalsInQuarter(b, 76, 90))
        } else {
          diff = (diff = (this.goalsInQuarter(b, 1, 15) + this.goalsInQuarter(b, 16, 30) + this.goalsInQuarter(b, 31, 45) +
              this.goalsInQuarter(b, 46, 60) + this.goalsInQuarter(b, 61, 75) + this.goalsInQuarter(b, 76, 90))) -
              (this.goalsInQuarter(a, 1, 15) + this.goalsInQuarter(a, 16, 30) + this.goalsInQuarter(a, 31, 45) +
                  this.goalsInQuarter(a, 46, 60) + this.goalsInQuarter(a, 61, 75) + this.goalsInQuarter(a, 76, 90))
        }
      }
      if (this.sortColumn === 'name' || diff === 0) {
        const nameA = a.short_name || a.name;
        const nameB = b.short_name || b.name;
        if (this.sortAscending) {
          diff = nameA.localeCompare(nameB);
        } else {
          diff = nameB.localeCompare(nameA);
        }
        return diff;
      }
			return diff;
		},
		isHighestValue(team, minTime, maxTime) {
			const values = [
				team['1-15'],
				team['16-30'],
				team['31-45'],
				team['46-60'],
				team['61-75'],
				team['76-90']
			];
			const maxVal = Math.max(...values);
      const val = team[`${minTime}-${maxTime}`];
      if (values.every(val => val === 0)) {
        return false;
      } else {
        return val === maxVal;
      }
		}
	}
}
</script>

<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.blur-right {
  @apply after:content-[''] after:bg-zt-more/25 after:shadow-[1px_0_2px_0_rgba(147,163,186,0.3)] after:w-[1px] after:top-0 after:h-full after:right-[2px] after:z-20 after:absolute;
}
.marked-box {
  height: v-bind(boxSize);
  width: v-bind(boxSize);
  @apply bg-zt-more text-center grid place-items-center rounded-zt;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.disabled-sort {
  @apply !no-underline !cursor-default hover:!brightness-100 focus:!brightness-100;
}
</style>